var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 85.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.139,85.935H25.5876c-1.1504,0-2.0831-0.9364-2.0831-2.0915s0.9327-2.0915,2.0831-2.0915h58.5428 c2.1146-0.0002,3.8285-1.7211,3.8285-3.8442v-0.7279c0-2.1237-1.7134-3.8459-3.8285-3.8484H15.8719 c-4.4166,0-7.9969-3.5947-7.9969-8.0292s3.5803-8.0292,7.9969-8.0292h9.4822c1.1504,0,2.0831,0.9364,2.0831,2.0915 c0,1.1552-0.9327,2.0915-2.0831,2.0915h-9.4822c-2.1156,0-3.8308,1.7221-3.8308,3.8462c0,2.1241,1.7152,3.8462,3.8308,3.8462 h68.2584c4.4134,0.0047,7.9901,3.5959,7.9946,8.0272v0.732c0.0046,4.4286-3.5676,8.0225-7.9784,8.0272c-0.0025,0-0.0056,0-0.0082,0 L84.139,85.935z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9385,0C36.5096,0.0023,25.6247,10.933,25.6247,24.4161c0,13.1638,22.0517,31.6735,22.989,32.4515 c0.771,0.6412,1.8868,0.6412,2.6577,0c0.9413-0.778,22.9887-19.2919,22.9887-32.4515l0,0C74.2439,10.9367,63.3636,0.0141,49.9385,0z  M49.9385,33.3467c-4.9056,0.0023-8.8842-3.9886-8.8867-8.9138c-0.002-4.9253,3.9724-8.92,8.878-8.9224 c4.9056-0.0023,8.8842,3.9886,8.8867,8.9138c0,0.0028,0,0.0056,0,0.0084C58.8165,29.3557,54.8415,33.3467,49.9385,33.3467z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrips);
export default __webpack_public_path__ + "static/media/trips.c29bbe472cc31a7a637e7beb8c741b11.svg";
export { ForwardRef as ReactComponent };